export enum EventsDateFilter {
  Current = 'current',
  // Upcoming = 'upcoming',
  Past = 'past',
  // InProgress = 'inprogress',
}
